import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { UserType } from '~/types';

type PostsSliceType = { company: null };

const initialState: PostsSliceType = { company: null };

export const companiesSlice = createSlice({
  name: 'companies',
  initialState,
  reducers: {
    setCompany: (state, action: PayloadAction<UserType | null>) => {
      state.company = action.payload;
    },
  },
});

export const { setCompany } = companiesSlice.actions;
